import { BadgeIcon } from "./BadgeIcon";
import { BadgeTooltip } from "./BadgeTooltip";
import {
  Tooltip,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface BadgeCardProps {
  badge: {
    id: string;
    name: string;
    description: string;
    badge_type: string;
  };
  isEarned: boolean;
}

export const BadgeCard = ({ badge, isEarned }: BadgeCardProps) => {
  return (
    <Tooltip key={badge.id}>
      <TooltipTrigger asChild>
        <div 
          className={`flex flex-col items-center bg-primary/10 dark:bg-gray-800/50 rounded-lg p-4 backdrop-blur-sm transition-all cursor-help
            ${isEarned 
              ? 'border-2 border-foreground hover:bg-clubbers-blue/10' 
              : 'opacity-50 hover:opacity-75 border-2 border-dashed border-gray-300'}`}
        >
          <div className={`mb-2 ${isEarned ? 'text-foreground' : 'text-gray-400'}`}>
            <BadgeIcon badgeType={badge.badge_type} />
          </div>
          <h3 className="text-sm text-foreground font-medium text-center">
            {badge.name}
          </h3>
        </div>
      </TooltipTrigger>
      <BadgeTooltip 
        name={badge.name}
        description={badge.description}
        isEarned={isEarned}
        badgeType={badge.badge_type}
      />
    </Tooltip>
  );
};